<div class="blockCardContainer">
    <div class="imageContainer" [style]="style">
        <img src="{{ image }}" [style]="style2">
    </div>
    <div class="contentContainer">
        <h1 [style]="style3">{{ title }}</h1>
        <h3 style="margin-top: 5px;">{{ subTitle }}</h3>
    </div>
</div>